import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import * as dt from 'core/datetime';
import { apiErrorHandler } from 'core/errors';
import { DATE_FORMAT } from 'globals/constants';
import { Dispatch } from 'redux';
import { UPDATE_ACADLY_COURSES } from 'redux/actions';
import { API, getCancelToken, request } from 'redux/api';
import { RootState } from 'redux/reducers';

interface FetchImportedCoursesResponse {
  message: string;
  courses: ImportedCourse<number>[];
}

interface AcadlyCoursesState {
  isLoading: boolean;
  courses: ImportedCourse[];
}

interface AcadlyCoursesProps extends ToastManagerProp {
  acadlyCourses: ImportedCourse[];
  updateAcadlyCourses(courses: ImportedCourse[]): Promise<void>;
}

class AcadlyCourses extends Component<AcadlyCoursesProps, AcadlyCoursesState> {
  apiSources = getCancelToken();

  constructor(props: AcadlyCoursesProps) {
    super(props);
    this.state = {
      isLoading: true,
      courses: [],
    };
  }

  async fetchImportedCourses() {
    return request<FetchImportedCoursesResponse>({
      url: API.COURSES_IMPORTED,
      cancelToken: this.apiSources.token,
    });
  }

  async componentDidMount() {
    try {
      this.apiSources = getCancelToken();
      const response = await this.fetchImportedCourses();
      const courses = response.courses.map((course) => ({
        ...course,
        createdOn: new Date(course.createdOn * 1000),
      }));
      this.props.updateAcadlyCourses(courses);
      this.setState({ courses, isLoading: false });
    } catch (err) {
      apiErrorHandler(this.props.toastManager, err, () => {
        this.setState({ isLoading: false });
      });
    }
  }

  componentWillUnmount() {
    this.apiSources.cancel();
  }

  getRow = (course: ImportedCourse) => {
    return (
      <tr key={course.code}>
        <td className='table__cell'>
          <div className='table__cell-header'>Course Code</div>
          <div className='table__cell-value'>{course.code}</div>
        </td>
        <td className='table__cell'>
          <div className='table__cell-header'>Title</div>
          <p className='table__cell-value text__truncate'>{course.title}</p>
        </td>
        <td className='table__cell'>
          <div className='table__cell-header'>Course Administrator</div>
          <div className='table__cell-value table__cell-value--no-wrap'>{course.courseAdmin.name}</div>
        </td>
        <td className='table__cell'>
          <div className='table__cell-header'>Created On</div>
          <div className='table__cell-value table__cell-value--no-wrap'>
            {dt.format(course.createdOn, DATE_FORMAT)}
          </div>
        </td>
      </tr>
    );
  };

  render() {
    const { isLoading, courses } = this.state;

    return (
      <div className='section'>
        <div className='section__header'>
          <h3 className='section__title'>
            {isLoading
              ? 'Loading courses...'
              : courses.length > 0
              ? `${courses.length} active courses on Acadly`
              : 'No active courses on Acadly yet'}
          </h3>
        </div>
        <div className='section__body'>
          <table className='table table--bordered'>
            <tbody>{courses.map(this.getRow)}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  acadlyCourses: state.acadlyCourses,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateAcadlyCourses: async (data: ImportedCourse[]) => {
    dispatch({
      type: UPDATE_ACADLY_COURSES,
      payload: data,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(AcadlyCourses));
